import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";
import "./EmptyState.css";

export interface EmptyStateProps extends Omit<HTMLAttributes<HTMLDivElement>, "title"> {
  icon?: ReactNode;
  /** One sentence on why it is empty. */
  title: ReactNode;
  description?: ReactNode;
  /** The single action that fixes it. */
  action?: ReactNode;
  /** Smaller padding for use inside table bodies and panels. */
  compact?: boolean;
}

/** "Nothing here yet — do this" block. */
export function EmptyState({
  icon,
  title,
  description,
  action,
  compact = false,
  className,
  ...rest
}: EmptyStateProps) {
  return (
    <div className={cx("ui-empty", compact && "ui-empty--compact", className)} {...rest}>
      {icon ? (
        <div className="ui-empty__icon" aria-hidden="true">
          {icon}
        </div>
      ) : null}
      <p className="ui-empty__title">{title}</p>
      {description ? <p className="ui-empty__description">{description}</p> : null}
      {action ? <div className="ui-empty__action">{action}</div> : null}
    </div>
  );
}
